var lib_core = require("lib-core");
var lib_geometry = require("lib-geometry");

var DrawingStateMachine = function (root, editorModel, selectionModel) {
    var self = this;

    this.root = root;

    this.editorModel = editorModel;
    this.selectionModel = selectionModel;

    lib_core.StateMachine.call(this);

    this.addEventAction("idle",
        function (cEvent) {
            return (cEvent.type() == lib_core.GuiEvents.EDITOR_MOUSE_MOVE);
        },
        function (cEvent) {
            self.editorModel.getSnappedMousePos();
        }
    );

    this.addEventAction("idle",
        function (cEvent) {
            return (cEvent.isKeyPressed('escape') || cEvent.type().isGuiButton);
        },
        function (cEvent) {
            self.editorModel.clearSnap();
        }
    );

    this.addTransition("idle","drawing",
        function(cEvent) {
            return (cEvent.type() == lib_core.GuiEvents.CANVAS_MOUSE_DOWN ||
                    cEvent.type() == lib_core.GuiEvents.ELEMENT_MOUSE_DOWN ||
                    cEvent.type() == lib_core.GuiEvents.HANDLE_MOUSE_DOWN);
        },
        function (cEvent) {
            self.selectionModel.emptySelection();
            self.root.rec();

            self.startCoord = self.editorModel.getSnappedMousePos();

            self.mouseDownCoord = new lib_geometry.Coord(
                cEvent.data('pageX'), cEvent.data('pageY')
            );
            self.element = self.createElement();

            self.element.setFocus(true);
        }
    );

    this.addTransition("drawing","drawing",
        function(cEvent) {
            return (cEvent.type() == lib_core.GuiEvents.EDITOR_MOUSE_MOVE);
        },
        function (cEvent) {
            var keys = {altKey: cEvent.data('altKey'), shiftKey: cEvent.data('shiftKey')};

            self.setElement(self.startCoord, self.editorModel.getSnappedMousePos(null, self.element), keys);
        }
    );

    this.addTransition("drawing","idle",
        function(cEvent) {
            return (cEvent.type() == lib_core.GuiEvents.CANVAS_MOUSE_UP);
        },
        function (cEvent) {
            // set min size when mouse down and up on placing is too small of an amount
            var mouseUpCoord = new lib_geometry.Coord(
                cEvent.data('pageX'), cEvent.data('pageY')
            );

            var diff = self.mouseDownCoord.sub(mouseUpCoord);
            if(Math.abs(diff.length()) <= 3) {
                self.setMinElement();
            }

            self.root.stopRec();
            self.editorModel.clearSnap();
            self.handle(cEvent);
        }
    );

    self.addTransition("drawing", "idle",
        function(cEvent) {
            return (cEvent.isKeyPressed("escape") || cEvent.type().isGuiButton);
        },
        function (cEvent) {
            self.root.cancelRec();
            self.editorModel.clearSnap();
            self.handle(cEvent);
        }
    );
};

lib_core.inherit(DrawingStateMachine, lib_core.StateMachine);

module.exports = DrawingStateMachine;

DrawingStateMachine.prototype.exitFunction = function () {
    if(this.element && this.element.isAlive()) this.selectionModel.addToSelection(this.element);
};

DrawingStateMachine.prototype.recordStartCoord = function () {
    this.startCoord = this.editorModel.getSnappedMousePos();
};

DrawingStateMachine.prototype.createElement = function () {
    throw new Error("createElement function should be implemented by the inheriting state machine");
};

DrawingStateMachine.prototype.setElement = function (startCoord, currentCoord, keys) {
    var minSide;

    if (keys.altKey === false && keys.shiftKey === false ) {
        this.element.pos(startCoord.add(currentCoord).mult(0.5));
        this.element.width(Math.abs(startCoord.x-currentCoord.x));
        this.element.height(Math.abs(startCoord.y-currentCoord.y));
    } else if (keys.altKey === true && keys.shiftKey === false) {
        this.element.pos(startCoord);
        this.element.width(2 * Math.abs(startCoord.x-currentCoord.x));
        this.element.height(2 * Math.abs(startCoord.y-currentCoord.y));
    } else if (keys.altKey === false && keys.shiftKey === true) {

        minSide = Math.min(Math.abs(startCoord.x-currentCoord.x), Math.abs(startCoord.y-currentCoord.y));

        var deltaVec = currentCoord.sub(startCoord);

        var center = startCoord.copy();

        if (deltaVec.x >= 0) {
            center.x += minSide/2;
        } else {
            center.x -= minSide/2;
        }

        if (deltaVec.y >= 0) {
            center.y += minSide/2;
        } else {
            center.y -= minSide/2;
        }

        this.element.pos(center);

        this.element.width(minSide);
        this.element.height(minSide);

    } else if (keys.altKey === true && keys.shiftKey === true) {

        this.element.pos(startCoord);

        minSide = Math.min(Math.abs(startCoord.x-currentCoord.x), Math.abs(startCoord.y-currentCoord.y));

        this.element.width(2 * minSide);
        this.element.height(2 * minSide);

    }

};

DrawingStateMachine.prototype.setMinElement = function() {
    this.element.width(this.options.minWidth);
    this.element.height(this.options.minHeight);
};

DrawingStateMachine.prototype.getElementInteractionModel = function(element) {
    return this.editorModel.interactionModelDataMap.get(element);
};
